import React from 'react';
const CHECKOUT_URL = 'https://pay.hotmart.com/V104786038J?off=jf7lbvvl';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  isCheckout?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  isCheckout = false
}: CTAButtonProps) {
  const sharedClasses = `
    inline-block relative group overflow-hidden rounded-xl font-extrabold text-xl md:text-2xl text-center
    bg-amber-500 text-amber-950 shadow-[0_0_40px_-10px_rgba(245,158,11,0.5)]
    transition-all duration-300 hover:bg-amber-400 hover:shadow-[0_0_60px_-10px_rgba(245,158,11,0.7)]
    hover:-translate-y-1 active:translate-y-0 cursor-pointer no-underline
    ${fullWidth ? 'w-full py-5 md:py-6' : 'px-10 py-5 md:px-14 md:py-6'}
    ${className}
  `;
  const innerContent = <>
      <span className="absolute inset-0 rounded-xl ring-2 ring-amber-400 ring-offset-2 ring-offset-slate-900 animate-pulse opacity-50" data-id="element-262"></span>
      <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-263"></span>
      <span className="relative flex items-center justify-center gap-2" data-id="element-264">
        {children}
      </span>
    </>;
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  if (isCheckout) {
    return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className={sharedClasses} data-id="element-265">
        {innerContent}
      </a>;
  }
  return <button onClick={onClick} className={sharedClasses} data-id="element-266">
      {innerContent}
    </button>;
}